var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-primary",class:_vm.data.class,attrs:{"to":{ name: _vm.data.componentName, params: _vm.param },"title":_vm.data.text}},[_c('i',{class:_vm.data.icon,attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.data.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4766bb4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AdminTools/divers/add-btn.vue
// module id = null
// module chunks = 